module.exports = __webpack_public_path__ + "static/media/coffee-nov30-dt-fr.463766f7.jpg";